/* eslint-disable default-case */
/* eslint-disable no-duplicate-case */
import moment from "jalali-moment";
import { SCHOOL_LEVELS } from "../constants/school";
import { WEEK_DAYS } from "../constants";

export function toHHMMSS(date, isHours = true, isMin = true, isSec = true) {
  var sec_num = parseInt(date); // don't forget the second param

  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  // var text = ""
  var text = isHours ? hours + (isMin ? ":" : "") : "";
  text += isMin ? minutes + (isSec ? ":" : "") : "";
  text += isSec ? seconds : "";
  return text;
}

export function handleSchoolLevelData(level, grade) {
  if (level === 0 || grade === null) return {};
  const levelData = SCHOOL_LEVELS.filter((i) => i.value === level)[0];
  const gradeData = levelData?.gradeOptions?.filter(
    (i) => i.value === grade,
  )[0];
  return levelData ?
      { ...levelData, grade: gradeData?.name, gradeNumber: gradeData?.value }
    : null;
}

export function generateCode(length = 7) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function handleAttributionText(value) {
  switch (value) {
    case "mother":
      return "مادر";
    case "father":
      return "پدر";
    case "protector":
      return "قیم";
  }
}
export function Jdate(date, timestamp = true, now = false, format = null) {
  var m = moment(!now ? new Date(timestamp ? date * 1000 : date) : Date());
  let lang = localStorage.getItem("language");
  m.locale(lang ?? "fa");
  var output =
    m.format("ddd") +
    " " +
    m.format("DD") +
    " " +
    m.format("MMM") +
    " " +
    m.format("YYYY") +
    ", " +
    m.format("HH:mm");
  return format ? enToFaDigit(m.format(format)) : output;
}

export function faToEnDigits(input) {
  if (input === undefined) return;
  var returnModel = "",
    symbolMap = {
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      "۰": "0",
    };
  input = input.toString();
  for (var i = 0; i < input.length; i++)
    if (symbolMap[input[i]]) returnModel += symbolMap[input[i]];
    else returnModel += input[i];
  return returnModel;
}

export function enToFaDigit(number) {
  let lang = localStorage.getItem("language");
  console.log("lang", lang);
  if (!number) return "۰";
  const data = {
    1: "۱",
    2: "۲",
    3: "۳",
    4: "۴",
    5: "۵",
    6: "۶",
    7: "۷",
    8: "۸",
    9: "۹",
    0: "۰",
  };
  let result = "";
  number = number.toString();

  for (var i = 0; i < number.length; i++) {
    if (data[number[i]]) result += data[number[i]];
    else result += number[i];
  }

  return lang && lang === "en" ? number : result;
}

export const isIran = (val) => {
  return /^^(\+98|0)?9\d{9}$$/.test(val);
};

export function rialToToman(value) {
  return enToFaDigit(Math.floor(value / 10));
}

export function numberWithCommas(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function throttledFunction(func, wait, immediate) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function statusData(status) {
  switch (status) {
    case "set":
      return { title: "درخواست اولیه", label: "default" };
    case "disable":
      return { title: "غیرفعال", label: "danger", color: "status_red" };
    case "enable":
      return { title: "قبول سفر", label: "info", color: "status_green" };
    case "fix":
      return {
        title: "تعیین پرداخت",
        label: "warning",
        color: "status_orange",
      };
    case "paid":
      return { title: "پرداخت شده", label: "success", color: "status_blue" };
    case "expired":
      return { title: "منقضی", label: "yellow", color: "status_yellow" };
    case "arrival":
      return { title: "پایان سفر", label: "success", color: "status_blue" };
    case "ontheway":
      return { title: "سفیر در مبدا", label: "success", color: "status_blue" };
    case "ride":
      return { title: "در مسیر مقصد", label: "success", color: "status_blue" };
    case "cancel":
      return {
        title: "راننده سفر شما را لغو کرد",
        label: "warning",
        color: "status_orange",
      };
    default:
      return { title: "نامشخص", label: "default", color: "status_gray" };
  }
}

export function calcTime(number) {
  let result = "";
  const time = new Date();
  time.setHours(0, 0);

  let i = 0;
  for (let value = 0; value <= number; value += 900) {
    const min = time.getMinutes() === 0 ? "00" : time.getMinutes();
    let hour = time.getHours().toString();
    hour =
      hour.length === 1 ?
        `${enToFaDigit("0")}${time.getHours()}`
      : time.getHours();

    if (value === number) {
      result = `${hour}:${min}`;
    }
    time.setHours(time.getHours(), time.getMinutes() + 15);
    i++;
  }
  return result;
}

export function carTypeToName(cars = [], type) {
  let result = "مشخص نیست";
  cars.forEach((car) => {
    if (type === car.label) {
      result = car.title;
    }
  });
  return result;
}

export function weekDaysNumberToWord(number) {
  const binary = number.toString(2);
  const daysArray = binary.split("").map((string) => Boolean(Number(string)));
  const itemsLength = daysArray.filter((day) => day === true);

  let words = "";
  WEEK_DAYS.forEach((day, index) => {
    if (daysArray[index]) {
      words += `${day}${index + 1 < itemsLength.length ? "," : ""}`;
    }
  });

  return words;
}

export function handleWebsiteAddress() {
  const host = window.location.host;
  const indexOfSubDomain = host.indexOf(".");
  const websiteAddress = host.substr(indexOfSubDomain + 1);
  return `${window.location.protocol}//${websiteAddress}`;
}

export function handleGenderText(gender) {
  switch (gender) {
    case "male":
      return "مرد";
    case "female":
      return "زن";
  }
}

export const getTimeUtc = (startDate, startTime, estimateTime) => {
  return (
    ((
      new Date(
        (startDate + startTime + estimateTime + 12600) * 1000,
      ).getUTCHours() < 10
    ) ?
      enToFaDigit("0")
    : "") +
    enToFaDigit(
      new Date((startDate + startTime + estimateTime + 12600) * 1000)
        .getUTCHours()
        .toString(),
    ) +
    ":" +
    ((
      new Date(
        (startDate + startTime + estimateTime + 12600) * 1000,
      ).getUTCMinutes() < 10
    ) ?
      enToFaDigit("0")
    : "") +
    enToFaDigit(
      new Date((startDate + startTime + estimateTime + 12600) * 1000)
        .getUTCMinutes()
        .toString(),
    )
  );
};
